export const FEATURES = {
  INVOICE_HAS_PDF: 'INVOICE_HAS_PDF',
  ROUND_TERM_TO_FRIDAY: 'ROUND_TERM_TO_FRIDAY',
  CUSTOM_LATAM_TERM: 'CUSTOM_LATAM_TERM',
};
